module.exports = __webpack_public_path__ + "media/images/icons/icons_large/67_doNotDisturbSign-f732e4baf9fc01ccc752308231edcda5.png";